"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AdjustFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AdjustFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0a1 1 0 0 1 1 1v1H15a1 1 0 1 1 0 2h-1.5v1a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1ZM0 3a1 1 0 0 1 1-1h8.5a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1ZM3.5 5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h1.5V6a1 1 0 0 1 1-1ZM5.5 8a1 1 0 0 1 1-1H15a1 1 0 1 1 0 2H6.5a1 1 0 0 1-1-1ZM8.5 10a1 1 0 0 1 1 1v1H15a1 1 0 1 1 0 2H9.5v1a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1ZM0 13a1 1 0 0 1 1-1h4.5a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AdjustFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AdjustFill;
exports["default"] = _default;